<template>
    <div id="dataStatistics">
      <el-row>
        <el-col :span="12">
            <h1 class="bgImg" style="margin:10px 0;">冻结集中时间</h1>
            <div style="width: 100%;height:320px;" >
              <barEacher1 :data="echartsData" ref="barEacher1"/>
            </div>
        </el-col>
        <el-col :span="12">
          <h1 class="bgImg" style="margin:10px 0;">最近的10天冻结数量变化</h1>
          <div style="width: 100%;height:320px;" >
            <linEchart :data="echartsData1" ref="linEchart"/>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
            <h1 class="bgImg" style="margin:10px 0;">最近的10个月冻结数量变化</h1>
            <div style="width: 100%;height:320px;" >
              <linEchart :data="echartsData2" ref="linEchart1"/>
            </div>
        </el-col>
        <el-col :span="12">
          <h1 class="bgImg" style="margin:10px 0;">本月运营商冻结数量</h1>
          <div style="width: 100%;height:320px;" >
            <barEacher :data="echartsData3" ref="barEacher"/>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
            <h1 class="bgImg" style="margin:10px 0;">本月运营商重复冻结数量与冻结率</h1>
            <div style="width: 100%;height:320px;" >
              <barEacher :data="echartsData4" ref="barEacher2"/>
            </div>
        </el-col>
      </el-row>
    </div>
  </template>
  <script>
  import common from '@/utils/common.js'
  import linEchart from './linEchart.vue'
  import barEacher from './barEacher.vue'
  import barEacher1 from './barEacher1.vue'
  export default {
    components:{
      linEchart,
      barEacher,
      barEacher1
    },
    data() {
      return {
        dataStatistics: {
  
        },
        echartsData:{   
          xData:[],
          yData:[{},{}],
        },
        echartsData1:{ 
          xData:[],
          yData:[{}],
        },
        echartsData2:{ 
          xData:[],
          yData:[{}],
        },
        echartsData3:{ 
          xData:[],
          yData:[{}],
        },
        echartsData4:{ 
          xData:[],
          yData:[{}],
        },
        cardStatistics: [],
  
      }
    },
    methods: {
  
  
  
    },
  
    created() {
      this.echartsData={   //波浪图
        xData:[],
        yData:[{data:[], name:"冻结数量", type: 'bar',barWidth: '20px'}],
      },
      this.echartsData1={
        xData:[],
        yData:[{data:[],  name:"冻结数量",type: 'line'}],
      },
      this.echartsData2={ //最近的10个月冻结数量变化
        xData:[],
        yData:[{data:[],name:"冻结数量",  type: 'line'}],
      },
      this.echartsData3={   //波浪图
        xData:[],
        yData:[{data:[], name:"本月运营商冻结数量", type: 'bar',barWidth: '20px'}],
      },
      this.echartsData4={   //波浪图
        xData:[],
        yData:[{data:[], name:"重复冻结数量", type: 'bar',barWidth: '20px'},{data:[], name:"总数量", type: 'bar',barWidth: '20px'},{data:[], name:"冻结率（%百分比）", type: 'bar',barWidth: '20px'}],
      },
      common.sysRequest('pool/countDong', {}, 'post').then(res => {
          this.dataStatistics=res.data.data;
          this.cardStatistics=res.data.data.poolList;
          if(Array.isArray(res.data.data.hourList) && res.data.data.hourList.length > 0){
            res.data.data.hourList.forEach(item=>{
              this.echartsData.xData.push(item.name)
              this.echartsData.yData[0].data.push(item.nums)
            })
            this.$nextTick(()=>{
              this.$refs.barEacher1.initChart()
            })
          }
          if(Array.isArray(res.data.data.dayList ) && res.data.data.dayList.length > 0){
            res.data.data.dayList.sort((b,a) => new Date(b.name).getTime() - new Date(a.name).getTime()).forEach(item=>{
              this.echartsData1.xData.push(item.name)
              this.echartsData1.yData[0].data.push(item.nums)
            })
            this.$nextTick(()=>{
              this.$refs.linEchart.initChart()
            })
          }
          if(Array.isArray(res.data.data.monthList ) && res.data.data.monthList.length > 0){
            res.data.data.monthList.sort((b,a) => new Date(b.name).getTime() - new Date(a.name).getTime()).forEach(item=>{
              this.echartsData2.xData.push(item.name)
              this.echartsData2.yData[0].data.push(item.nums)
            })
            this.$nextTick(()=>{
              this.$refs.linEchart1.initChart()
            })
          }
          
          if(Array.isArray(res.data.data.supplierList ) && res.data.data.supplierList.length > 0){
            res.data.data.supplierList.forEach(item=>{
              this.echartsData3.xData.push(item.name)
              this.echartsData3.yData[0].data.push(item.nums)
            })
            this.$nextTick(()=>{
              this.$refs.barEacher.initChart()
            })
          }

          if(Array.isArray(res.data.data.chongfuMonthList ) && res.data.data.chongfuMonthList.length > 0){
            res.data.data.chongfuMonthList.forEach(item=>{
              this.echartsData4.xData.push(item.name)
              this.echartsData4.yData[0].data.push(item.chongfuNum)
              this.echartsData4.yData[2].data.push(item.chongParent)
            })
            this.$nextTick(()=>{
              this.$refs.barEacher2.initChart()
            })
          }
      })
    },
  
    updated() {
  
    },
  
    watch: {
  
    },
  }
  </script>  
  <style lang="less" scoped>
  .row-item {
    .el-col-12 {
      padding: 10px;
    }
  }
  ::v-deep .el-tabs--border-card {
    background: #F3F5F9;
  }
  
  h1.bgImg {
    // background: url(./../../assets/icon5.png) no-repeat left center;
    // padding-left:36px;
    font-size: 16px;
    color: #19213F;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  
  </style>